import React, { useState, useEffect, useCallback } from 'react';
import { HiShoppingCart } from 'react-icons/hi2';
import { getOrders } from '../../services/api';
import { format } from 'date-fns';

const statusBadge = s => {
  const map = { pending: 'badge-yellow', confirmed: 'badge-blue', dispatched: 'badge-purple', delivered: 'badge-green', cancelled: 'badge-red' };
  return <span className={`badge ${map[s] || 'badge-gray'}`}>{s}</span>;
};

export default function CustomerOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: 15 };
      if (statusFilter) params.status = statusFilter;
      const { data } = await getOrders(params);
      setOrders(data.data);
      setTotal(data.total);
    } catch {
    } finally {
      setLoading(false);
    }
  }, [page, statusFilter]);

  useEffect(() => { load(); }, [load]);

  const totalPages = Math.ceil(total / 15);

  return (
    <div className="content-area">
      <div className="page-header">
        <div>
          <h1 className="page-title">My Orders</h1>
          <p className="text-muted">{total} total orders</p>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <div className="card-body" style={{ paddingBottom: '1rem' }}>
          <div className="filter-bar">
            <div>
              <label className="form-label">Filter by Status</label>
              <select
                className="form-control"
                value={statusFilter}
                onChange={e => { setStatusFilter(e.target.value); setPage(1); }}
                style={{ width: 180 }}
              >
                <option value="">All Orders</option>
                {['pending', 'confirmed', 'dispatched', 'delivered', 'cancelled'].map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-center"><div className="spinner" /></div>
        ) : orders.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
            <HiShoppingCart style={{ fontSize: '3rem', display: 'block', margin: '0 auto 0.75rem' }} />
            No orders found.
          </div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Total</th>
                  <th>Discount</th>
                  <th>Status</th>
                  <th>Order Date</th>
                  <th>Delivery Date</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {orders.map(o => (
                  <tr key={o.id}>
                    <td><span className="badge badge-blue">{o.order_number}</span></td>
                    <td style={{ fontWeight: 700 }}>₹{parseFloat(o.total_amount).toFixed(2)}</td>
                    <td>{parseFloat(o.discount) > 0 ? <span style={{ color: '#16a34a' }}>-₹{parseFloat(o.discount).toFixed(0)}</span> : '-'}</td>
                    <td>{statusBadge(o.status)}</td>
                    <td>{format(new Date(o.order_date), 'dd MMM yyyy')}</td>
                    <td>{o.delivery_date ? format(new Date(o.delivery_date), 'dd MMM yyyy') : '-'}</td>
                    <td className="text-muted" style={{ fontSize: '0.8125rem' }}>{o.notes || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {totalPages > 1 && (
          <div style={{ padding: '1rem 1.5rem' }}>
            <div className="pagination">
              <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</button>
              {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => i + 1).map(p => (
                <button key={p} className={page === p ? 'active' : ''} onClick={() => setPage(p)}>{p}</button>
              ))}
              <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
